import Sentry from "@similarweb/sentry-logger";

export class ComponentsUtils {
    public static getSupportForPassiveEvents(): boolean {
        let supportsPassive = false;
        try {
            (document as any).addEventListener(
                "test",
                null,
                {
                    get passive() {
                        supportsPassive = true;
                        return true;
                    },
                },
                { capture: true },
            );
        } catch (e) {}
        return supportsPassive;
    }

    /**
     * * ensure component has been rendered completely (http://stackoverflow.com/questions/26556436/react-after-render-code)
     * @param callback
     * @param delta
     */
    public static ensureRenderCompleted(callback: FrameRequestCallback, delta = 0) {
        setTimeout(() => {
            window.requestAnimationFrame(callback);
        }, delta);
    }

    public static createDomRoot(name: string) {
        const rootId = `${name}_${String(Math.random()).slice(2)}`;
        const root = document.createElement("div");
        root.id = rootId;
        try {
            document.body.appendChild(root);
        } catch (e) {
            Sentry.fatal("cannot append root element", e);
        }
        return root;
    }

    public static deleteDomRoot(element: HTMLElement) {
        document.body.removeChild(element);
    }

    public static parseURLQueryString(url: string) {
        const urlParams: Record<string, string> = {};
        // @ts-ignore FIXME: strict migration - callback type mismatch — return value is discarded so the missing return is intentional
        url.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function ($0: string, $1: string, $2: string, $3: string) {
            urlParams[$1] = decodeURIComponent($3);
        });
        return urlParams;
    }
}
